export default {
  title: {
    'zh-cn': '字典管理',
    'zh-tw': '字典管理',
    'en': 'Dictionary Management'
  },
  // 设备状态
  DeviceStatusType: {
    '0': {
      'zh-cn': '离线',
      'zh-tw': '離線',
      'en': 'Offline'
    },
    '1': {
      'zh-cn': '在线',
      'zh-tw': '在線',
      'en': 'Online'
    }
  },
  // 4G状态
  deviceFourGStatus: {
    '0': {
      'zh-cn': '未开通',
      'zh-tw': '未開通',
      'en': 'Inactive'
    },
    '1': {
      'zh-cn': '开通',
      'zh-tw': '開通',
      'en': 'Active'
    }
  },
  // 设备模式
  deviceMode: {
    '0': {
      'zh-cn': '正常模式',
      'zh-tw': '正常模式',
      'en': 'Normal Mode'
    },
    '1': {
      'zh-cn': '维护模式',
      'zh-tw': '維護模式',
      'en': 'Maintenance Mode'
    }
  },
  // 认证状态
  authStatus: {
    '0': {
      'zh-cn': '未认证',
      'zh-tw': '未認證',
      'en': 'Unauthenticated'
    },
    '1': {
      'zh-cn': '已认证',
      'zh-tw': '已認證',
      'en': 'Authenticated'
    },
    '2': {
      'zh-cn': '认证未通过',
      'zh-tw': '認證未通過',
      'en': 'Authentication Failed'
    }
  },
  // 绑定状态
  bindingState: {
    '0': {
      'zh-cn': '未绑定',
      'zh-tw': '未綁定',
      'en': 'Unbound'
    },
    '1': {
      'zh-cn': '已绑定',
      'zh-tw': '已綁定',
      'en': 'Bound'
    }
  },
  // 入出类型
  InOutType: {
    'In': {
      'zh-cn': '入',
      'zh-tw': '入',
      'en': 'In'
    },
    'Out': {
      'zh-cn': '出',
      'zh-tw': '出',
      'en': 'Out'
    },
    'Between': {
      'zh-cn': '换区',
      'zh-tw': '換區',
      'en': 'Zone Transfer'
    }
  },
  // 通道类型
  channelTypeDict: {
    '0': {
      'zh-cn': '无视频通道',
      'zh-tw': '無視頻通道',
      'en': 'No Video Channel'
    },
    '3': {
      'zh-cn': '多视频通道',
      'zh-tw': '多視頻通道',
      'en': 'Multi Video Channel'
    }
  },
  // 升级状态
  upgradeStatus: {
    'Waiting': {
      'zh-cn': '等待升级',
      'zh-tw': '等待升級',
      'en': 'Waiting'
    },
    'Cancel': {
      'zh-cn': '取消升级',
      'zh-tw': '取消升級',
      'en': 'Cancel'
    },
    'Success': {
      'zh-cn': '升级成功',
      'zh-tw': '升級成功',
      'en': 'Success'
    },
    'Failure': {
      'zh-cn': '升级失败',
      'zh-tw': '升級失敗',
      'en': 'Failure'
    },
    'Upgrading': {
      'zh-cn': '正在升级',
      'zh-tw': '正在升級',
      'en': 'Upgrading'
    }
  }
}

